import React from "react";
import { Nav } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import "./MainFooterComponent.scss";

// image imports

function MainFooterComponent() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="main-footer-wrapper">
      <p>
        עוצב על ידי<strong>Beomy tech</strong>
      </p>
      <div className="footer-main-links">
        <Nav className="navbar-main-footer">
          <Nav.Link
            onClick={() => navigate("/terms_privacy")}
            className={`nav-item ${
              location.pathname === "/terms_privacy" ? "nav-item-active" : ""
            }`}>
            תנאי שימוש
          </Nav.Link>
          <Nav.Link
            onClick={() => navigate("/help")}
            className={`nav-item ${location.pathname === "/help" ? "nav-item-active" : ""}`}>
            עזרה
          </Nav.Link>
        </Nav>
      </div>
      <p className="copy-right" style={{ direction: "ltr" }}>
        GoBeB -כל הזכויות שמורות ל ©
      </p>
    </div>
  );
}

export default MainFooterComponent;
